function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  id: "high--risk--users_1_",
  d: "M1.36,25H0.64v-5.587c0-2.907,1.797-5.441,4.461-6.428c-1.033-0.755-1.667-1.969-1.667-3.279 c0-2.242,1.824-4.065,4.065-4.065c0.087,0,0.173,0.002,0.259,0.008C7.68,5.331,7.64,5.004,7.64,4.671 c0-2.223,1.808-4.031,4.031-4.031s4.031,1.808,4.031,4.031c0,1.297-0.626,2.499-1.647,3.249c1.819,0.678,3.273,2.109,3.974,3.952 l-0.674,0.256c-0.717-1.885-2.315-3.288-4.276-3.753c-0.15-0.035-0.261-0.163-0.275-0.316c-0.014-0.154,0.071-0.3,0.212-0.363 c1.195-0.532,1.967-1.719,1.967-3.024c0-1.826-1.485-3.311-3.311-3.311S8.36,2.845,8.36,4.671c0,0.382,0.064,0.753,0.189,1.106 c1.735,0.464,3.016,2.049,3.016,3.928c0,1.311-0.634,2.525-1.668,3.281c2.501,0.936,4.292,3.293,4.462,5.991l-0.719,0.045 c-0.167-2.667-2.108-4.963-4.72-5.583c-0.15-0.036-0.261-0.163-0.275-0.317s0.071-0.299,0.212-0.362 c1.208-0.537,1.988-1.736,1.988-3.055c0-1.845-1.501-3.346-3.346-3.346S4.154,7.861,4.154,9.706c0,1.319,0.78,2.518,1.988,3.055 c0.141,0.063,0.226,0.208,0.212,0.362s-0.125,0.281-0.275,0.317c-2.778,0.659-4.719,3.115-4.719,5.973C1.36,19.413,1.36,25,1.36,25z  M31.312,31.18c0.064-0.111,0.064-0.249,0-0.36l-11-19c-0.129-0.223-0.494-0.223-0.623,0l-11,19c-0.064,0.111-0.064,0.249,0,0.36 C8.752,31.291,8.871,31.36,9,31.36h22C31.129,31.36,31.248,31.291,31.312,31.18z M20,12.718L30.376,30.64H9.625L20,12.718z  M20.5,27.5c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5S19.724,28,20,28S20.5,27.776,20.5,27.5z M20.36,21h-0.72v5h0.721 L20.36,21L20.36,21z"
});
const SvgHighRiskUsers = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 32 32",
  style: {
    enableBackground: "new 0 0 32 32"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, /*#__PURE__*/React.createElement("rect", {
  id: "_Transparent_Rectangle",
  style: {
    fill: "none"
  },
  width: 32,
  height: 32
}));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHighRiskUsers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/high--risk--users.14294913.svg";
export { ForwardRef as ReactComponent };